import { Flex } from "antd";
import { t } from "i18next";
import { AppForm, RegistrationInput, AppButton, AppText } from "@/shared/Components";
import type { SmsCodeFormProps } from "@/entities/sms-code-form/model";
import styles from "./styles.module.scss";

export const Mobile = ({
  formApi,
  submitDisabled,
  isLoading,
  onSubmit,
  onResend,
  resendCoolDown,
}: SmsCodeFormProps) => {
  return (
    <AppForm className={styles.form} formApi={formApi} onSubmit={onSubmit}>
      <Flex gap={32} vertical>
        <RegistrationInput placeholder={t("passwordRecoveryPage.smsCode")} name="code" />
        <Flex className={styles.buttons} justify="space-between" gap={8}>
          <AppButton
            htmlType="submit"
            type="primary"
            className={styles.submit}
            disabled={submitDisabled}
            loading={isLoading}
          >
            {t("passwordRecoveryPage.confirm")}
          </AppButton>
        </Flex>
        {resendCoolDown > 0 ? (
          <AppText type="secondary" className={styles.resend}>
            {t("registrationPage.phoneVerifyStep.sending", {
              coolDown: resendCoolDown,
            })}
          </AppText>
        ) : (
          <AppButton type="primary" className={styles["resend-button"]} onClick={onResend}>
            {t("registrationPage.phoneVerifyStep.getNew")}
          </AppButton>
        )}
      </Flex>
    </AppForm>
  );
};
